import { Box, Skeleton, TableCell, TableRow } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyle = makeStyles((theme) => ({
  rsTableCellLoader: {
    "&>span": {
      transform: "scale(1)",
    },
  },
  rsMainTable: {
    width: "350px",
    height: "100px",
    marginLeft: "20px",
    marginBottom: "30px",
  },
}));

const GroupLoader = (props) => {
  const { rows, cells } = props;

  const classes = useStyle();

  return (
    <>
      {[...Array(rows)]?.map((item) => {
        return (
          <TableRow>
            {[...Array(cells)]?.map((cell) => {
              return (
                // <TableCell className={classes.rsTableCellLoader}>
                <Box className={classes.rsMainTable}>
                  <Skeleton style={{ width: "350px", height: "150px" }} />
                </Box>

                // </TableCell>
              );
            })}
          </TableRow>
        );
      })}
    </>
  );
};

export default GroupLoader;
